import { useTheme } from "@emotion/react";
import { Toolbar, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { farawayLogo } from "../../staticData/images";
import SocialMediaIcons from "../SocialMediaIcons";
import { gotoUrl } from "../../utils";
const FooterHome = ({ ddu = false }) => {
  const { palette, ...theme } = useTheme();

  return (
    <>
      <Box
        sx={{
          zIndex: 1000,
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          paddingTop: 1,
        }}
      >
        <Toolbar
          variant="dense"
          sx={{
            padding: "0 !important",
            margin: "0 !important",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              "& button": { color: palette.grey[200] },
            }}
          >
            <Box
              sx={{
                width: "100%",
                paddingLeft: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box
                style={{
                  paddingLeft: "2vw",
                  zIndex: "10000 !important",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                  }}
                >
                  <img
                    style={{
                      paddingLeft: "8px",
                      height: "2.2vw",
                      width: "auto",
                    }}
                    src="https://storage.googleapis.com/3d-container/inceptivestudios.png"
                    alt="inceptive studios company "
                    loading="lazy"
                  />
                  <img
                    style={{
                      paddingLeft: "8px",
                      height: "1.8vw",
                      width: "auto",
                    }}
                    src="https://storage.googleapis.com/3d-container/icons/MADE%20BY%20APE.png"
                    alt="made by ape coin"
                    loading="lazy"
                  />
                </Box>

                <Typography
                  sx={{
                    textAlign: "center",
                    fontFamily: "var(--font-i_r)",
                    fontSize: "0.4vw",
                    color: "#C4C4C4",
                    [theme.breakpoints.down("sm")]: {
                      fontSize: "10px",
                    },
                  }}
                >
                  © 2024 Inceptive Studio All rights reserved.
                </Typography>
              </Box>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "var(--font-i_r)",
                    color: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "row",
                    fontSize: {
                      xl: "1em",
                      lg: "0.7em",
                      md: "0.4em",
                      xs: "0.8em",
                      sm: "0.8em",
                    },

                    marginRight: "8px",
                  }}
                >
                  Building On
                </Typography>
                <div
                  style={{
                    height: "18px",
                    width: "1px",
                    background: "#C4C4C4",
                    // border: "1px solid #fff",
                  }}
                />
                <img
                  style={{
                    cursor: "pointer",
                    paddingLeft: "24px",
                    height: "1.3vw",
                    width: "auto",
                  }}
                  onClick={() => gotoUrl("https://apechain.com/")}
                  variant="square"
                  src="https://storage.googleapis.com/3d-container/ApechainHighRes.svg"
                  alt="Ape chain"
                  loading="lazy"
                />

                <img
                  style={{
                    cursor: "pointer",
                    paddingLeft: "24px",
                    height: "1.3vw",
                    width: "auto",
                  }}
                  onClick={() => gotoUrl("https://unity.com/")}
                  src="https://storage.googleapis.com/3d-container/Unity%20logo.png"
                  alt="made by unity"
                  loading="lazy"
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  marginRight: "4vh",
                }}
              >
                <SocialMediaIcons ddu={ddu} username="@LetsApeCom" />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    // onClick={() => {
                    //   !ddu && navigate("/faq");
                    // }}
                    sx={{
                      verticalAlign: "center",
                      paddingLeft: "24px",
                      fontFamily: "var(--font-i_r)",
                      color: "#fff",
                      userSelect: "none",
                      opacity: 0.7,
                      fontSize: {
                        xl: "0.9em",
                        lg: "0.5em",
                        md: "0.4em",
                        xs: "0.7em",
                        sm: "0.7em",
                      },
                    }}
                  >
                    FAQ
                  </Typography>
                  <Box
                    style={{
                      height: "12px",
                      width: "1px",
                      marginLeft: "24px",
                      background: "#C4C4C4",
                      // border: "1px solid #fff",
                    }}
                  />

                  <Typography
                    // onClick={() => !ddu && handleOpenPricyPolicy(false)}
                    sx={{
                      verticalAlign: "center",
                      paddingLeft: "24px",
                      // padding: "0px 12px",
                      fontFamily: "var(--font-i_r)",
                      color: "#fff",
                      opacity: 0.7,
                      userSelect: "none",
                      fontSize: {
                        xl: "0.9em",
                        lg: "0.5em",
                        md: "0.4em",
                        xs: "0.7em",
                        sm: "0.7em",
                      },
                    }}
                  >
                    Terms
                  </Typography>
                  <Box
                    style={{
                      height: "12px",
                      width: "1px",
                      marginLeft: "24px",
                      background: "#C4C4C4",
                      // border: "1px solid #fff",
                    }}
                  />

                  <Typography
                    // onClick={() => !ddu && handleOpenPricyPolicy(true)}
                    sx={{
                      verticalAlign: "center",
                      fontFamily: "var(--font-i_r)",
                      paddingLeft: "24px",
                      color: "#fff",
                      opacity: 0.7,
                      userSelect: "none",
                      fontSize: {
                        xl: "0.9em",
                        lg: "0.5em",
                        md: "0.4em",
                        xs: "0.7em",
                        sm: "0.7em",
                      },
                    }}
                  >
                    Privacy
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </Box>
    </>
  );
};

export default FooterHome;
